export default (updateSearch) => {
  Array.from(document.querySelectorAll('.product-search__filter-checkbox')).forEach((input) => {
    input.addEventListener('change', () => {
      updateSearch({ [input.name]: input.value }, input.checked ? 'APPEND' : 'REMOVE', input);
    });
    if (input.checked) {
      updateSearch({ [input.name]: input.value }, 'APPEND');
    }
  });
  Array.from(document.querySelectorAll('.releases-search__filter-checkbox')).forEach((input) => {
    input.addEventListener('change', () => {
      updateSearch({ [input.name]: input.value }, input.checked ? 'APPEND' : 'REMOVE', input);
    });
    if (input.checked) {
      updateSearch({ [input.name]: input.value }, 'APPEND');
    }
  });
};
